var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { TableBodyCell, TableCellEmpty, TableCellText } from '@pocketlaw/tetris';
export function SimpleValuesCell(props) {
    const { value, allowedValues } = props, rest = __rest(props, ["value", "allowedValues"]);
    const textValues = Array.isArray(value) ? value.join(', ') : value;
    const allowedValue = (allowedValues === null || allowedValues === void 0 ? void 0 : allowedValues.length) ? allowedValues.find((item) => item.value === value) : undefined;
    const text = (allowedValues === null || allowedValues === void 0 ? void 0 : allowedValues.length) ? allowedValue === null || allowedValue === void 0 ? void 0 : allowedValue.text : textValues;
    if (!text) {
        return (<TableBodyCell {...rest}>
        <TableCellEmpty />
      </TableBodyCell>);
    }
    return (<TableBodyCell {...rest}>
      <TableCellText primary={text}/>
    </TableBodyCell>);
}
